// src/core/domain/status.js
//
// Pure status classifications. Returns lowercase strings.
// Callers map the string to their own labels and CSS variables.

export const statusBelowOrEqual = (value, threshold) => {
  if (value === undefined || value === null || isNaN(value)) return 'unknown';
  return value <= threshold ? 'good' : 'bad';
};

export const statusAboveOrEqual = (value, threshold) => {
  if (value === undefined || value === null || isNaN(value)) return 'unknown';
  return value >= threshold ? 'good' : 'bad';
};

// Three-way comparison against a baseline with symmetric tolerance.
// value and baseline must be in the same unit.
export const statusFromBaseline = (value, baseline, tolerance) => {
  if (value === undefined || value === null || isNaN(value)) return 'unknown';
  if (baseline === undefined || baseline === null || isNaN(baseline)) return 'unknown';
  if (value < baseline - tolerance) return 'low';
  if (value > baseline + tolerance) return 'high';
  return 'normal';
};

// Classifies live data status. Returns 'connecting' | 'live' | 'offline'.
export const classifyLiveStatus = ({ loading, error, hasData }) => {
  if (error) return 'offline';
  if (loading || !hasData) return 'connecting';
  return 'live';
};